/* Account */
export const GET_ACCOUNT = "GET_ACCOUNT";
export const GET_ACCOUNT_SUCCESS = "GET_ACCOUNT_SUCCESS";
export const GET_ACCOUNT_ERROR = "GET_ACCOUNT_ERROR";

export const GET_ACCOUNTS = "GET_ACCOUNTS";
export const GET_ACCOUNTS_SUCCESS = "GET_ACCOUNTS_SUCCESS";
export const GET_ACCOUNTS_ERROR = "GET_ACCOUNTS_ERROR";

export const GET_CURRENT_USER_ACCOUNT_OWNER = "GET_CURRENT_USER_ACCOUNT_OWNER";
export const GET_CURRENT_USER_ACCOUNT_OWNER_SUCCESS =
  "GET_CURRENT_USER_ACCOUNT_OWNER_SUCCESS";
export const GET_CURRENT_USER_ACCOUNT_OWNER_ERROR =
  "GET_CURRENT_USER_ACCOUNT_OWNER_ERROR";

export const ADD_ACCOUNT = "ADD_ACCOUNT";
export const ADD_ACCOUNT_SUCCESS = "ADD_ACCOUNT_SUCCESS";
export const ADD_ACCOUNT_ERROR = "ADD_ACCOUNT_ERROR";

export const MODIFY_ACCOUNT = "MODIFY_ACCOUNT";
export const MODIFY_ACCOUNT_SUCCESS = "MODIFY_ACCOUNT_SUCCESS";
export const MODIFY_ACCOUNT_ERROR = "MODIFY_ACCOUNT_ERROR";

export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_ERROR = "DELETE_ACCOUNT_ERROR";
